import * as React from "react";
import { Grid, MenuItem, TextField } from "@material-ui/core";

import { Limits } from "Utility/Limits";

import { ZeroQuiltSize } from "Model/IQuiltSize";
import { BlockOrdering } from "Model/BlockOrdering";
import { IBlockQuiltParams } from "Model/IBlockQuiltParams";

import { SizeField } from "Components/SizeField";
import { NumberField } from "Components/NumberField";

export interface IProps {
    readonly params: IBlockQuiltParams;

    readonly onChanged: (params: IBlockQuiltParams) => void;
}

export function BlockEditor(props: IProps): React.ReactElement {
    const onRandomCountChanged = (value: number) => {
        props.onChanged({
            ...props.params,
            randomCount: value
        });
    };

    const onOrderingChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        const ordering = parseInt(event.target.value);
        if (isNaN(ordering)) {
            return;
        }

        props.onChanged({
            ...props.params,
            ordering
        });
    };

    const padding = props.params.padding ?? ZeroQuiltSize;

    const onPaddingChanged = (w: number, h: number) => {
        props.onChanged({
            ...props.params,
            padding: {
                width: w,
                height: h
            }
        });
    };

    return (
        <form>
            <Grid container direction="row" spacing={1}>
                <Grid item xs>
                    <NumberField
                        fullWidth
                        isInteger
                        label={"Block count"}
                        value={props.params.randomCount}
                        onChanged={onRandomCountChanged}
                        min={0}
                        max={Limits.MaxRandomCount}/>
                </Grid>
                
                <Grid item xs>
                    <TextField
                        select
                        fullWidth
                        margin="dense"
                        label="Ordering"
                        value={props.params.ordering}
                        onChange={onOrderingChanged}>
                        <MenuItem value={BlockOrdering.Alternate}>Alternate</MenuItem>
                        <MenuItem value={BlockOrdering.Row}>Row</MenuItem>
                        <MenuItem value={BlockOrdering.Column}>Column</MenuItem>
                    </TextField>
                </Grid>
            </Grid>
            <SizeField
                widthStr={"Pad width (in)"}
                heightStr={"Pad height (in)"}

                width={padding.width}
                height={padding.height}

                widthMin={0}
                widthMax={Limits.MaxPadding}

                heightMin={0}
                heightMax={Limits.MaxPadding}

                onChanged={onPaddingChanged} />
        </form>
    );
}